import React, { useState } from "react";
import "../../Styles/AuthStyle.css";

import {
  FormWrapper,
  FormInput,
  FormLabel,
  FormInputRow,
  FormMessage,
  Button,
  FormTitle,
} from "../../components/StyledComp/StyledComp";

import AdminUserService from "../../services/adminUserServices";
import { useNavigate, useParams } from "react-router-dom";
import SignInLogo from "./SignInLogo";
import { isShowLoader } from "../../store/apiSlice";
import LoaderComponent from "../../components/StyledComp/Loader";
import { useDispatch } from "react-redux";
interface IState {
  user: {
    password: string;
    confirmation: string;
  };
}

const ResetPassword: React.FC = () => {
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [state, setState] = useState<IState>({
    user: {
      password: "",
      confirmation: "",
    },
  });
  const { verificationString } = useParams();
  const dispatch = useDispatch();

  console.log("verificationString", verificationString);

  const messageVariants = {
    hidden: { y: 30, opacity: 0 },
    animate: { y: 0, opacity: 1, transition: { delay: 0.2, duration: 0.4 } },
  };

  const updateInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    // console.log("updateinput  ", state);
    // console.log("updateinput1  ", event.target.name);
    setState({
      user: {
        ...state.user,
        [event.target.name]: event.target.value,
      },
    });
  };

  const setPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    console.log("setPassword");
    dispatch(isShowLoader(true));

    event.preventDefault();
    if (state.user.password != state.user.confirmation) {
      alert("password doesnot match");
      return;
    }

    const response = await AdminUserService.forGotPasswordResetPassword(
      verificationString as string,
      state.user.password
    );
    console.log("response", response);
    if (response.data.data != null) {
      alert("password updated successfully. Please login");
      dispatch(isShowLoader(false));

      navigate("/sign-in", { replace: true });
    } else {
      console.log("**error***");
      console.log(response.data.errors);
      setError(response.data.errors);
    }
  };

  const formData = [
    {
      label: "Password",
      name: "password",
      placeHolder: "Enter your password",
      value: state.user.password,
      onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
        updateInput(event),
      type: "password",
      autoComplete: "new-password",
    },
    {
      label: "Confirmation",
      name: "confirmation",
      placeHolder: "Re-Enter your password",
      value: state.user.confirmation,
      onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
        updateInput(event),
      type: "password",
      autoComplete: "new-password",
    },
  ];

  return (
    <div className="signin-wrapper">
      <LoaderComponent />
      <div className="signin col-12 col-lg-8">
        <div className="signin-logo col-12 col-lg-5">
          <SignInLogo />
        </div>
        {/* Sign In section */}
        <div className="signin-form col-12 col-lg-7">
          <FormTitle>Reset Password</FormTitle>
          <FormWrapper onSubmit={(e) => setPassword(e)}>
            {formData.map((el, index) => (
              <FormInputRow key={index}>
                <FormLabel>{el.label}</FormLabel>
                <FormInput
                  type={el.type}
                  name={el.name}
                  placeholder={el.placeHolder}
                  value={el.value}
                  autoComplete={el.autoComplete}
                  required
                  // onChange={(event: React.ChangeEvent<HTMLInputElement>) => updateInput(event)}
                  onChange={(
                    event: React.ChangeEvent<HTMLInputElement>
                  ): void => updateInput(event)}
                />
              </FormInputRow>
            ))}

            <div className="loginbutton">
              <Button type="submit">Confirm</Button>
            </div>
          </FormWrapper>
          {error && (
            <FormMessage
              className="ErrorDiv"
              variants={messageVariants}
              initial="hidden"
              animate="animate"
            >
              {error}
            </FormMessage>
          )}
          {/* {success && (
              <FormMessage
                variants={messageVariants}
                initial="hidden"
                animate="animate"
                error={false}
              >
                {success}
              </FormMessage> 
            )}  */}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
